"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeGuideAlpha = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const cotopaxi_1 = require("@as/cotopaxi");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const HtmlInclude_1 = require("../../common/html-include/HtmlInclude");
const EventUtil_1 = tslib_1.__importDefault(require("../../../util/EventUtil"));
const EventEnum_1 = require("../../../enums/EventEnum");
const andes_react_1 = require("@yonderland/andes-react");
const andes_icons_1 = require("@yonderland/andes-icons");
const react_redux_1 = require("react-redux");
const ProductSelector_1 = require("../../../redux/product/selectors/ProductSelector");
const common_components_1 = require("@as-react/common-components");
const ProductActions_1 = require("../../../redux/product/actions/ProductActions");
const AnalyticsActions_creators_1 = require("../../../redux/analytics/actions/AnalyticsActions.creators");
const SizeGuideAlpha = () => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.product);
    const { pdpTemplateName } = (0, common_components_1.useAemConfig)();
    const { sizeGuideContent, sizeGuideContentUrl } = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetSizeGuideData)());
    const dispatch = (0, react_redux_1.useDispatch)();
    const isPopup = Boolean(sizeGuideContent);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = (0, cotopaxi_1.usePopoverHandlers)({
        close: () => setIsOpen(false),
    });
    const handleSizeGuideOpen = () => {
        dispatch(ProductActions_1.productActions.sizeGuideOpen());
        dispatch(AnalyticsActions_creators_1.analyticsActions.productDetailSizeGuideClick(pdpTemplateName));
        if (isPopup) {
            setIsOpen(true);
        }
        else {
            window.open(sizeGuideContentUrl, '_blank');
        }
    };
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            handlePopoverOpen(null, null, true);
            setTimeout(() => EventUtil_1.default.dispatch(EventEnum_1.EventEnum.SIZE_GUIDE_POPOVER_OPEN), cotopaxi_1.POPOVER_ANIMATION_DURATION);
        }
    }, [isOpen]);
    if (!sizeGuideContent && !sizeGuideContentUrl) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(andes_react_1.Box, { children: [(0, jsx_runtime_1.jsx)(andes_react_1.LinkButton, { testId: "size_guide", iconLeft: { source: andes_icons_1.RulerIcon, size: 'xs' }, onClick: handleSizeGuideOpen, text: t('product.size.guide.link') }), isPopup && ((0, jsx_runtime_1.jsx)(cotopaxi_1.Popover, { anchorEl: anchorEl, type: cotopaxi_1.PopoverType.MODAL, onClose: handlePopoverClose, title: t('product.size.guide.link'), dataQA: "size_guide_popup", children: (0, jsx_runtime_1.jsx)(HtmlInclude_1.HtmlInclude, { htmlFragment: sizeGuideContent }) }))] }));
};
exports.SizeGuideAlpha = SizeGuideAlpha;
